import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  toggleFormContainer: {
    position: 'relative',
  },
  toggleCloseButton: {
    color: theme.palette.neutralDark,
    position: 'absolute',
    top: pxToRem(10),
    right: pxToRem(10),
    selectors: {
      '&:hover': {
        color: theme.palette.themeDarker,
      },
    },
  },
  filterAddButton: {
    marginTop: pxToRem(16),
  },
  productAddButton: {
    marginTop: pxToRem(16),
  },
  productAutosuggest: {
    position: 'relative',
    marginTop: pxToRem(16),
  },
});
